import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import MovieCard from "@/components/feature/MovieCard";
import { movies, type MediaType } from "@/lib/media";

const tabs: { key: "all" | MediaType; label: string }[] = [
  { key: "all", label: "全部" },
  { key: "movie", label: "电影" },
  { key: "tv", label: "电视剧" },
  { key: "variety", label: "综艺" },
  { key: "anime", label: "动画" },
];

export default function HotMoviesSection() {
  const [tab, setTab] = useState<"all" | MediaType>("all");

  const list = useMemo(() => {
    const sorted = [...movies].sort((a, b) => b.heat - a.heat);
    const filtered = tab === "all" ? sorted : sorted.filter((item) => item.type === tab);
    return filtered.slice(0, 8);
  }, [tab]);

  return (
    <section aria-label="热门影视推荐">
      <SectionHeading
        eyebrow="Trending now"
        title="热门影视推荐"
        subtitle="综合站内热度与评分，为你挑选此刻最值得打开的作品"
        actionLabel="更多影视"
        actionTo="/category/movie"
      >
        <div className="hidden items-center gap-1 rounded-full bg-background-100 p-1 md:flex">
          {tabs.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => setTab(item.key)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1 text-xs transition-colors ${
                tab === item.key
                  ? "bg-primary-500 font-medium text-background-50"
                  : "text-foreground-600 hover:text-primary-700"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </SectionHeading>

      <div className="mb-4 flex items-center gap-1 overflow-x-auto bg-background-100 p-1 no-scrollbar md:hidden">
        {tabs.map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => setTab(item.key)}
            className={`flex-1 cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-xs transition-colors ${
              tab === item.key
                ? "bg-primary-500 font-medium text-background-50"
                : "text-foreground-600"
            }`}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4">
        {list.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>

      <div className="mt-4 flex items-center justify-between rounded-lg border border-background-200 bg-background-100 px-4 py-3">
        <p className="text-xs leading-5 text-foreground-500">
          <i className="ri-fire-line mr-1 text-accent-500" aria-hidden="true" />
          热度由站内收藏、讨论与播放意向综合计算（演示数据）
        </p>
        <Link to="/category/tv" className="whitespace-nowrap text-xs font-medium text-primary-700 hover:text-accent-600">
          查看剧集榜
        </Link>
      </div>
    </section>
  );
}